/** Drill-down target branch. Absent means the viewer's active branch. */
export const SALES_LEAGUE_BRANCH_ID_QUERY_PARAM = 'branchId';

/**
 * `setActiveBranchId` stores this sentinel when handed an empty value, and the branch
 * slice starts empty — so the active branch is unusable until `getCurrentUserInfo`
 * resolves.
 */
export const UNRESOLVED_BRANCH_ID = '-';
